import React, { useEffect, useState } from "react";
import { Button, Modal, message } from "antd";
import { Container } from "react-bootstrap";
import Excel from "../../../Assets/Images/excel-icons-animation.gif";
import { AiOutlineCloseCircle } from "react-icons/ai";
import * as XLSX from "xlsx";
import styles from "../styles";

function ExcelDeliveryList(props) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (props.data && props.data.length > 0) {
      GenerateData(props.data);
    } else {
      setIsLoading(false);
      message.error("No data available");
    }
  }, [props.data]);

  const GenerateData = (data) => {
    let newArr = [...data]; // Use the sorted data from props
    let results = [];
    let newResults = [];

    // Maintain existing logic for singlebox and multipleboxes
    for (let i = 0; i < newArr.length; i++) {
      if (newArr[i + 1]?.collection_id === newArr[i]?.collection_id) {
        results.push(newArr[i]);
      } else {
        newResults.push(newArr[i]);
      }
    }

    try {
      let newar = [];
      newResults.forEach((item) => {
        let desc = CreateDescription(
          item.collection.boxes,
          item.airway_bill_no
        );
        let obj = {
          "BOX NO": desc[0],
          REFERENCE: desc[2],
          Pcs: desc[3],
          WEIGHT: desc[1],
          "DIMENSIONS (L X B X H)": desc[4],
          "SHIPPER ADDRESS": `${
            item.collection.sender_name?.toUpperCase() || ""
          } , PHONE:${item.collection.sender_phone || ""}   
            ${
              item.collection.sender_address
                ? item.collection.sender_address.toUpperCase()
                : ""
            }`,
          "CONSIGNEE ADDRESS": `${
            item.collection.reciver_name?.toUpperCase() || ""
          },  ${item.collection.reciver_address?.toUpperCase() || ""}  ${
            item.collection.reciver_distrcit?.toUpperCase() || ""
          } ${item.collection.reciver_state?.toUpperCase() || ""}  PIN :  ${
            item.collection.reciver_pincode || ""
          }  ${
            item.collection.reciver_post
              ? item.collection.reciver_post.toUpperCase()
              : ""
          }  PHONE : ${item.collection.reciver_phone || ""} , ${
            item.collection.reciver_altphone || ""
          } ${item.collection.recivercountries?.name?.toUpperCase() || ""}`,
          STATE: item.collection.reciver_state?.toUpperCase() || "",
          DIST: item.collection.reciver_distrcit?.toUpperCase() || "",
        };
        newar.push(obj);
      });
      setData(newar);
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setIsLoading(false);
      message.error("Error processing data");
    }
  };

  const CreateDescription = (boxes, val) => {
    try {
      let desc = "";
      let totalWeight = 0;
      let ref = "";
      let pieces = 0;
      let dimensions = "";

      // Sort boxes by box_number in ascending order
      const sortedBoxes = [...boxes].sort((boxA, boxB) => {
        const aValue = boxA?.box_number?.toString() || "";
        const bValue = boxB?.box_number?.toString() || "";
        const isNumericA = !isNaN(aValue) && aValue.trim() !== "";
        const isNumericB = !isNaN(bValue) && bValue.trim() !== "";

        if (isNumericA && isNumericB) {
          return Number(aValue) - Number(bValue);
        } else {
          return aValue.localeCompare(bValue, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }
      });

      sortedBoxes.forEach((ite) => {
        if (ite.airway_bill_no === val) {
          desc += ite?.box_number + ",";
          totalWeight += ite?.chargable_weight || 0;
          ref += ite?.box_ref_no
            ? ite.box_ref_no + ","
            : ite?.referance_details
            ? ite.referance_details + ","
            : "";
          pieces++;
          dimensions += `${ite?.length || 0} x ${ite?.breadth || 0} x ${
            ite?.height || 0
          },\n`;
        }
      });

      return [
        desc,
        Math.round(totalWeight * 100) / 100,
        ref,
        pieces,
        dimensions,
      ];
    } catch (err) {
      console.log(err);
      return ["", 0, "", 0, ""];
    }
  };

  const downloadExcel = (data) => {
    const headerTitle = `${
      props.selected && props.selected.orijin_airport_name
    }     - ${props.selected && props.selected.destination_airport_name} - (${
      props.selected.airline
    } - ${props.selected.awb_no} )  (${props.selected.psc || data.length} PCS)`;
    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: [headerTitle],
    });
    XLSX.utils.sheet_add_json(sheet, data, { origin: "A3" });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet);
    XLSX.writeFile(
      workbook,
      `${props.selected.airline} - ${props.selected.awb_no} deliverylist.xls`
    );
  };

  return (
    <div>
      <Modal
        visible={props.visible}
        onCancel={props.onClose}
        width={300}
        footer={false}
      >
        <div>
          <Container>
            <br />
            <div className="print-manifest-box1">
              {isLoading ? (
                <>
                  <img src={Excel} className="print-manifest-img" />
                  <div>Fetching data....</div>
                  <div>Downloading ....</div>
                </>
              ) : (
                <>
                  {data && data.length ? (
                    <>
                      <img src={Excel} className="print-manifest-img" />
                      <div>File is ready For download</div>
                      <br />
                      <Button onClick={() => downloadExcel(data)}>
                        Download As Excel
                      </Button>
                    </>
                  ) : (
                    <>
                      <AiOutlineCloseCircle size={50} color={"red"} />
                      <div style={{ margin: 20 }} />
                      <div>No data found.</div>
                    </>
                  )}
                </>
              )}
              <br /> <br />
              <Button type="primary" onClick={props.onClose}>
                Close
              </Button>
            </div>
          </Container>
        </div>
      </Modal>
    </div>
  );
}

export default ExcelDeliveryList;
